<template>
  <section class="content" style="padding-left: 0px;padding-right: 0px;">
    <!-- ========Doucments=========== -->
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div>
          <h2 class="home-topic" >Documents</h2>
        <div class="row">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3" v-for="doc in allDocuments" v-bind:key="doc.id">
            <div class="sg-str" @click="favoritDocument(doc.id)">
              <i :class="[doc.favourite=='yes'?'fa fa-star':'fa fa-star-o']" aria-hidden="true">
              </i>
            </div>
            <router-link :to="'/documents/single-dcument/'+doc.category_id+'/'+doc.id">
            <div class="v-boxx">
              <div class="v-videoo">
                 <img class="doc-img" v-bind:src='"https://smartapprcp.s3.ap-southeast-1.amazonaws.com/" + doc.thumbnail '  >
              </div>
              <div class="v-content">
                <p class="v-name two-line-overflow">{{doc.name}}</p>
                <!-- <ul class="v-name two-line-overflow2" style="padding-left:0;" >
                  <li class="badge bgg-pr"  v-for="product in doc.products">
                    {{product.pro_name}}
                  </li>
                </ul> -->
                <p class="v-disc two-line-overflow">{{doc.description}}</p>
              </div>
            </div>
             </router-link>
          </div>
        </div>
        </div>
      </div>
    </div>
     <div class="row" v-if="noContentErrorMsg">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        No results found
      </div>
    </div>
    <back-to-top bottom="120px" right="20px" visibleoffset="20">
      <button type="button" class="scoller-top-btn"><i class="fa fa-chevron-up"></i></button>
    </back-to-top>
  </section>
</template>
<script>
  import api from '../../../api'
  import Alert from '../../widgets/Alert'
  import InfoBox from '../../widgets/InfoBox'
  import ProcessInfoBox from '../../widgets/ProcessInfoBox'
  import SmallBox from '../../widgets/SmallBox'
  import VueContentLoading from 'vue-content-loading'
  import BackToTop from 'vue-backtotop'

  export default {
    name: 'homeView',
    components: {
      Alert,
      InfoBox,
      ProcessInfoBox,
      SmallBox,
      VueContentLoading,
      BackToTop
    },
    data() {
      return {
        allDocuments: [],
        searchKeyWord: '',
        isSearchEnable: false,
        dashboardSearchParam: 'd',
        noContent: 'yes',
        noContentErrorMsg: false
      }
    },
    mounted() {
    },
    created() {
      this.getAllData()
    },
    methods: {
      favoritVideo(id) {
        this.favouriteBackendCall('videos', id)
      },
      favoritDocument(id) {
        this.favouriteBackendCall('documents', id)
      },
      favouriteBackendCall(mediaType, id) {
        api.request('get', '/customer/favourite/' + mediaType + '/' + id)
          .then(response => {
            this.getAllData()
          })
      },
      getAllData() {
        var ref = this
        api.request('get', '/customer/dashboard/m?' + 'is_dashboard=' + ref.dashboardSearchParam + '&search_key=' + ref.searchKeyWord)
          .then(response => {
            this.allDocuments = response.data.documents
            if (this.allDocuments.length === 0) {
              this.noContentErrorMsg = true
            }
          })
      }
    }
  }
</script>
<style>
  @media (min-width: 320px) and (max-width: 480px) {
    .video-list-thumbs .glyphicon-play-circle {
      font-size: 35px;
      right: 36%;
      top: 27%;
    }

    .video-list-thumbs h2 {
      bottom: 0;
      font-size: 12px;
      height: 22px;
      margin: 8px 0 0;
    }
  }
  .top-right {
    position: absolute;
    top: 8px;
    right: 16px;
  }
</style>



// WEBPACK FOOTER //
// AllDocumentsView.vue?51528a9a